import React from 'react';

import PropTypes from 'prop-types';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

import './LabelTooltip.scss';

const LabelTooltip = ({ title }) => {
    return (
        <OverlayTrigger
            placement="right"
            overlay={
                <Tooltip>
                    {title}
                </Tooltip>
            }
        >
            <span
                className="label-tooltip"
            >
                i
            </span>
        </OverlayTrigger>

    );
};

LabelTooltip.propTypes = {
    title: PropTypes.string.isRequired,
};

export default LabelTooltip;

